import React, { useState, useEffect } from "react";
import "./Contact.css";
import axiosApi from "./axiosApi";
import { IconButton } from '@mui/material';

const initialFormState = {
  hostelName: "",
  ownerName: "",
  address: "",
  mobileNumber: "",
  email: "",
  totalBeds: "",
  message: "",
};

const Contact = ({
  open,
  onClose,
  propertyTypes = ["HOSTEL", "PG"],
}) => {
  const [form, setForm] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
const [errorMessage, setErrorMessage] = useState("");
console.log("propertyTypes:", propertyTypes);
const isHostelSite =
  propertyTypes.includes("HOSTEL") ||
  propertyTypes.includes("PG");

const showPricing = false;
  // 🔒 Lock scroll + RESET when popup opens/closes
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      // RESET EVERYTHING on open
      setForm(initialFormState);
      setSuccessMessage("");
      setErrorMessage("");
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      await axiosApi.post("/public/createHostelOwnerEnquiry", {
        hostelOwnerEnquiryDTO: form,
      });

      setSuccessMessage("Thank you! Our team will contact you shortly 🙏");

     

    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message ||
        "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-backdrop">
      <div className="contact-card popup">

        {/* CLOSE BUTTON */}
        <IconButton
  onClick={onClose}
  aria-label="close"
  sx={{
    position: 'absolute',
    top: 15,
    right: 2,

    width: 40,
    height: 40,
    borderRadius: '50%',

    backgroundColor: 'rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.08)',

    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },

    fontSize: '20px',
    fontWeight: 500,
    color: '#333',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  ×
</IconButton>

    <h2>
  {isHostelSite
    ? "🏨 Manage Your Hostel / PG with HostelandPG"
    : "🏨 Manage Your Property with GuestOpsy"}
</h2>

<p className="sub-text">
  {isHostelSite
    ? "All-in-one hostel & PG management."
    : "All-in-one hotel, homestay & property management."}
</p>

        {showPricing && (
  <div className="pricing-box">
    <p>✔ First <b>5 months – FREE</b></p>
    <p>✔ After that: <b>₹10 per bed / month</b></p>
  </div>
)}

        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}

        {errorMessage && (
          <div className="error-message">{errorMessage}</div>
        )}

        <form onSubmit={handleSubmit}>
        <input
  name="hostelName"
  placeholder={
    isHostelSite
      ? "Hostel / PG Name"
      : "Property Name"
  }
  value={form.hostelName}
  onChange={handleChange}
  required
/>
          <input name="ownerName" placeholder="Owner / Manager Name" value={form.ownerName} onChange={handleChange} required />
          <textarea
  name="address"
  placeholder={
    isHostelSite
      ? "Hostel Address"
      : "Property Address"
  }
  rows="2"
  value={form.address}
  onChange={handleChange}
  required
/>
          <input name="mobileNumber" placeholder="Mobile Number" value={form.mobileNumber} onChange={handleChange} required />
          <input name="email" placeholder="Email Address" value={form.email} onChange={handleChange} />
         <input
  name="totalBeds"
  placeholder={
    isHostelSite
      ? "Total Beds (optional)"
      : "Total Rooms / Units (optional)"
  }
  value={form.totalBeds}
  onChange={handleChange}
/>
          <textarea name="message" placeholder="Message (optional)" rows="2" value={form.message} onChange={handleChange} />

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>

      </div>
    </div>
  );
};

export default Contact;
